/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DocumentTemplateFilledField
 */
export interface DocumentTemplateFilledField {
    /**
     * 
     * @type {string}
     * @memberof DocumentTemplateFilledField
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentTemplateFilledField
     */
    value: string;
}

/**
 * Check if a given object implements the DocumentTemplateFilledField interface.
 */
export function instanceOfDocumentTemplateFilledField(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "value" in value;

    return isInstance;
}

export function DocumentTemplateFilledFieldFromJSON(json: any): DocumentTemplateFilledField {
    return DocumentTemplateFilledFieldFromJSONTyped(json, false);
}

export function DocumentTemplateFilledFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): DocumentTemplateFilledField {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'value': json['value'],
    };
}

export function DocumentTemplateFilledFieldToJSON(value?: DocumentTemplateFilledField | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'value': value.value,
    };
}

